// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PORx","top":"styles_top__2_0IU","left":"styles_left__1sXIu","description":"styles_description__2Je7I"};